import { useMemo } from 'react'
import { App } from 'realm-web'

function useApp() {
    const appId = useMemo(() => process.env.REACT_APP_APP_ID, [])
    const app = useMemo(() => new App({ id: appId }), [appId])

    return { app }
}

export default useApp
